export const environment = {
  production: false,
  apiUrl: 'https://devbe.carevance.solutions',
  onboardingUrl: 'https://onboardingdevbe.carevance.solutions',
  commonLookupUrl: 'https://commondevapi.carevance.solutions',
  twilioUrl: 'https://twilioapidev.carevance.solutions',
  demoUrl: 'https://demoapi.carevance.solutions',
  careManagerPortalUrl: 'https://caremanagerapidev.carevance.solutions',
  microserviceurl: 'https://servicemanagementdevapi.carevance.solutions',
  logisticUrl: 'https://logisticsapidev.carevance.solutions',
  ragUrl: 'https://rag-chat-api.carevance.solutions',
  demoNew: 'https://auto-calls.carevance.solutions',
  doctorUrl: 'https://doctordevapi.carevance.solutions',
};
